import React, { useEffect } from 'react';
import Wrapper from './styles';
import { useOrderContext } from '../../context/order_context';
import { Link , useLocation} from 'react-router-dom';
import { OrderContent, PageHero, Loading, Error } from '../../components';
import { toast } from 'react-toastify';
import axios from "axios"
import { useCartContext } from '../../context/cart_context';


const OrdersPage = () => {
  const {
    orders,
    orders_loading: loading,
    orders_error: error,
  } = useOrderContext();
  const {cart, clearCart}=useCartContext()
const { search } = useLocation();

  useEffect(() => {
    document.title = 'Mukunda jewelery | Orders';
  }, []);
   const updateProductQuantity = async () => {
      try {
        await Promise.all(
          cart.map((item) =>
        { let res=axios.put(
              `${process.env.REACT_APP_BACKEND_HOST}/api/products/${item.id}/updateQuantity`,
              {
                quantity: item.amount,
              }
            )
          }
          )
        );
        clearCart()
  
      } catch (error) {
        console.error('Error updating product quantities:', error);
      }
    };

    useEffect(() => {
      const payment = new URLSearchParams(search).get('payment');
      if (payment === 'success') {
         updateProductQuantity();
         toast.success('Payment is successful, mukunda jewellers will reach you through whatsapp service');
        
      } else if (payment === 'failed') {
        toast.error('Payment failed. Please try again.');
      }

      if (payment) {
        window.history.replaceState({}, document.title, '/orders');
      }
    }, []);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error />;
  }

  if (orders.length < 1) {
    return (
      <Wrapper className='page-100 h-[60vh]'>
        <div className='h-full empty flex flex-col justify-center items-center'>
          <h2>You have no orders</h2>
          <Link
            to='/collections'
            className='btn'
            style={{ backgroundColor: '#D3A143' }}
          >
            buy
          </Link>
        </div>
      </Wrapper>
    );
  }
  return (
    <main>
      <PageHero title='orders' />
      <Wrapper className='page'>
        {orders?.map((order) => {
          return <OrderContent key={order?.id} {...order} />;
        })}
        <div className='link-container'>
          <Link
            to='/collections'
            className='link-btn'
            style={{ backgroundColor: '#D3A143' }}
          >
            shop more
          </Link>
        </div>
      </Wrapper>
    </main>
  );
};

export default OrdersPage;
